import React, { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Button, Typography, responsiveFontSizes } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelSuccess from '../../componentes/labels/LabelSuccess';
import LabelError from '../../componentes/labels/LabelError';
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import productService from "./ProductService";
import InputField from "../../componentes/form-fields/InputField/InputField";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import DefaultChip from "../../componentes/chip/DefaultChip";

export default function ProductUfi() {
    const { t } = useTranslation();
    const { control } = useForm();



    const userId = sessionStorage.getItem("userId");
    const initialProductState = {
        idProduct: 0,
        idClient: 2,
        productName: '',
        multiUfi: '',
        jdeCode: '',
        ufiCode: '',
        type: '',
        channelMarket: '',
        mann: '',
        hengst: '',
        Mahle: '',
        tecfil: '',
        vox: '',
        fram: '',
        wega: '',
        fleetguard: '',
        parker: '',
        donaldson: '',
        sofima: '',
        hydac: '',
        outros: '',
        status: 1,
        label: 1,
        userId: userId,
    };

    const [product, setProduct] = useState(initialProductState);

    const { idProduct, vox, label, fram, wega, fleetguard, parker, donaldson, sofima, hydac, outros, productName, jdeCode, ufiCode, mann, hengst, Mahle, tecfil, idClient, status } = product

    const [clearedProduct, setClearedProduct] = useState(false);
    const [programRoleRows, setProductRows] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    const columnsProduct = (t) => [
        {
            field: "idCliente",
            textAlign: 'center',
            visible: false,
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="idCliente" name="" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="standard"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.idClient}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "idProduct",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="ids" name="id" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="standard"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.idProduct}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "productName",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="productName" name="productName" />;
            },
        },
        {
            field: "jdeCode",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="jdeCode" name="code" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="standard"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.jdeCode}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "ufiCode",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="ufiCode" name="qrCode" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="standard2"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.ufiCode}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "status",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="statusCode" name="status" />;
            },
            template: (props) => {
                return (
                    <>
                        {props.status ? (
                            <IconSwitch name="active" />
                        ) : (
                            <IconSwitch name="canceled" />
                        )}
                    </>
                );
            },
        },
        {
            field: "label",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="toLabel" name="status" />;
            },
            template: (props) => {
                return (
                    <>
                        {props.label === 1 ? (
                            t("yes")
                        ) : (
                            t("no")
                        )}
                    </>
                );
            },
        },


    ];


    const handleChange = (event) => {
        const { name, value } = event.target;
        setProduct({ ...product, [name]: value });
    };

    const handleCloseAlertProduct = () => {
        setProduct({ ...product });
        setError(false);
        setSuccess(false);
    };

    const handleClearProduct = () => {
        setClearedProduct(!clearedProduct);
        setProduct(initialProductState);
        setProductRows([]);
        setError(false);
        setSuccess(false);
    };

    const handleSearchProduct = () => {
        let request = {
            ...product
        }

        productService
            .getProductUfi(request)
            .then((response) => {
                setProductRows(response.data)
            })
            .catch((e) => {
                setProductRows([]);
            });
    };

    const canSaveProduct = () => {
        if (!productName || !jdeCode || !ufiCode || !idClient) {
            setError(true);
            setMessage(t("fillRequiredFields"));
            return false;
        } else if (status === 0) {
            console.log("status cancelado", status);
            setError(true);
            setMessage(t("errorCannotRegisterCancelledProduct"));
            return false;
        }

        setError(false);
        return true;
    };

    const canUpdateProduct = () => {
        if (!productName || !jdeCode || !ufiCode || !idClient || status === 2 || label === 2) {
            setError(true);
            setMessage(t("fillRequiredFields"));
            return false;
        }

        setError(false);
        return true;
    };

    const handleSaveProduct = () => {
        let request = { ...product, userId: userId };



        if (idProduct !== 0) {
            if (!canUpdateProduct()) return;
        } else {
            if (!canSaveProduct()) return;
        }

        setMessage("");
        setSuccess(false);
        setProduct({ ...product, warningProduct: false });
        productService
            .createProductUfi(request)
            .then((response) => {
                setProduct({ ...product, id: response.data.idProduct });
                setProductRows(response.data)
                setMessage(t("saveSuccess"));
                setSuccess(true);
                handleSearchProduct();
            })
            .catch((e) => {
                setMessage(t("saveError"));
                handleWarningProduct();
            });
    };

    const handleWarningProduct = () => {
        setProductRows([]);
        if (product.idRole !== 0) {
            setProduct({ ...product, warningProduct: true });
        }
    };

    const handleClickGrid = (rowData) => {
        setMessage("");
        setSuccess(false);

        setProduct({
            idProduct: rowData.idProduct,
            productName: rowData.productName,
            multiUfi: rowData.multiUfi,
            jdeCode: rowData.jdeCode,
            ufiCode: rowData.ufiCode,
            type: rowData.type,
            channelMarket: rowData.channelMarket,
            mann: rowData.mann,
            hengst: rowData.hengst,
            Mahle: rowData.Mahle,
            tecfil: rowData.tecfil,
            vox: rowData.vox,
            fram: rowData.fram,
            wega: rowData.wega,
            fleetguard: rowData.fleetguard,
            parker: rowData.parker,
            donaldson: rowData.donaldson,
            sofima: rowData.sofima,
            hydac: rowData.hydac,
            outros: rowData.outros,
            idClient: rowData.idClient,
            productGroup: rowData.productGroup,
            qttyBox: rowData.qttyBox,
            status: rowData.status,
            label: rowData.label
        });
    }

    useEffect(() => {
        handleSearchProduct();
    }, [])

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="product"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                error={error}
                                success={success}
                                message={message}
                                handleCloseAlert={handleCloseAlertProduct}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>
                                <Grid item xs={12} sm={3} md={3}>
                                    <div style={{
                                        pointerEvents: "none",
                                        opacity: 0.8
                                    }}>
                                        <DefaultAutocomplete
                                            iconLabelSwitch={
                                                <IconLabelSwitch
                                                    name="unLock"
                                                    labelName="client"
                                                />
                                            }
                                            name="idClient"
                                            disabled={true}
                                            value={idClient}
                                            defaultSize
                                            useApi
                                            endpoint='GetClient'
                                            error={error && idClient === 0}

                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="productName" labelName="productName" />
                                        }
                                        name="productName"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={productName}
                                        length={50}
                                        error={error && productName === ""}
                                    />
                                </Grid>
                            </GridInputRow>
                            <GridInputRow>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="jdeCode"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={jdeCode}
                                        length={30}
                                        error={error && jdeCode === ""}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="ufiCode"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={ufiCode}
                                        length={30}
                                        error={error && ufiCode === ""}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="mann"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={mann}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="hengst"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={hengst}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="mahle"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={Mahle}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="tecfil"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={tecfil}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="vox"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={vox}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="fram"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={fram}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="wega"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={wega}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="fleetguard"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={fleetguard}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="parker"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={parker}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="donaldson"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={donaldson}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="sofima"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={sofima}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="hydac"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={hydac}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="outros"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={outros}
                                        length={30}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                        error={error && status === 2}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"label"}
                                        onChange={handleChange}
                                        value={label}
                                        label={t("toLabel")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("no"), status: 1 },
                                            { id: 1, name: t("yes"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                        error={error && label === 2}
                                    />
                                </Grid>

                            </GridInputRow>
                            <SearchClearSaveRow
                                onClickClear={handleClearProduct}
                                onClickSearch={handleSearchProduct}
                                onClickSave={handleSaveProduct}
                            />

                        </GridItemContainer>
                    </>
                }
            />
            {programRoleRows.length > 0 ? (
                <DefaultScreenAccordion

                    fields={
                        <DefaultDatagrid
                            columns={columnsProduct(t, handleSearchProduct)}
                            dataSource={programRoleRows}
                            cellSelected={(args, grid) => handleClickGrid(args.data)}
                            allowPaging={true}
                        />
                    } />
            ) : null}
        </>
    );
};
